import { Box, IconButton, Typography } from "@mui/material";
import { downloadFile } from "../../page/foldermanagement/fileDownload.util";
import moment from "moment";
import { FontFamily } from "../theme/fontFamily";
import { fontWeight } from "../theme/fontWeight";
import { fontSize } from "../theme/fontSize";
import { ThemeColor } from "../theme/color";
import { DownCircleOutlined } from "@ant-design/icons";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import Linkify from 'react-linkify';


export const ReceiverSection = (data) => {
  /**
   * Was fetching through cors-anywhere.herokuapp.com - a public demo proxy that
   * is rate-limited and usually unavailable - with nothing catching the
   * rejection, so a download attempt could take the page over with "Failed to
   * fetch". The shared helper fetches directly and falls back to opening the
   * file in a new tab when the browser blocks it.
   */
  const handleDownload = (fileUrl) => {
    const name = String(fileUrl || "").split("?")[0].split("/").pop();
    return downloadFile({ url: fileUrl, name: name || "download" });
  };

  const FileHandler = (data) => {
    // console.log(data.url);
    return (
      data?.url?.length > 0 &&
      data.url.map((fileUrl, index) => {
        const fileExtension = fileUrl?.split(".").pop().toLowerCase();
        const urlParts = fileUrl?.split("/");
        const fullFileName = urlParts[urlParts.length - 1];
        // console.log(fileUrl, fileExtension, urlParts, fullFileName);

        if (fileExtension === "xlsx") {
          return (
            <div key={index} className="mt-2 d-flex align-items-center">
              <div className="filename-icon">
                <img
                  src="/assest/folderpng/excel.png"
                  alt="file icon"
                  className="w-100 h-100"
                />
              </div>
              <a
                href={fileUrl}
                download={fullFileName}
                style={{ textDecoration: "none", color: "blue" }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W400}
                  fontSize={fontSize.h4.medium}
                  color={ThemeColor.BLACK}
                  align="left"
                >
                  {fullFileName}
                </Typography>
              </a>
            </div>
          );
        } else if (fileExtension === "docx" || fileExtension === "doc") {
          return (
            <div className="mt-2 d-flex align-items-center" key={index}>
              <div className="filename-icon">
                <img
                  src="/assest/folderpng/word.png" // You can change this path as per your icon location
                  alt="Word Icon"
                  className="w-100 h-100"
                />
              </div>
              <a
                href={fileUrl}
                download={fullFileName}
                style={{ textDecoration: "none", color: "blue" }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W400}
                  fontSize={fontSize.h4.medium}
                  color={ThemeColor.BLACK}
                  align="left"
                >
                  {fullFileName}
                </Typography>
              </a>
            </div>
          );
        } else if (fileExtension === "pdf") {
          return (
            <div key={index} className="mt-2 d-flex align-items-center">
              <div className="filename-icon">
                <img
                  src="/assest/folderpng/pdf.png"
                  alt="file icon"
                  className="w-100 h-100"
                />
              </div>
              <a
                href={fileUrl}
                target="_blank"
                download={fullFileName}
                style={{ textDecoration: "none", color: "blue" }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W400}
                  fontSize={fontSize.h4.medium}
                  color={ThemeColor.BLACK}
                  align="left"
                >
                  {fullFileName}
                </Typography>
              </a>
            </div>
          );
        } else {
          return (
            <div key={index} className="mt-2">
              <img
                onClick={() => handleDownload(fileUrl)}
                src={fileUrl}
                style={{
                  width: "100px",
                  height: "100px",
                }}
                alt="chatimg"
              />
            </div>
          );
        }
      })
    );
  };

  return (
    <div className="chat-row chat-row-in">
      <div className="chat-bubble chat-bubble-in">
        <Typography className="chat-bubble-sender">
          {data.sender?.firstName} {data.sender?.lastName}
        </Typography>

        {data && FileHandler(data)}

        {data.text ? (
          <Typography className="chat-bubble-text">
            <Linkify
              componentDecorator={(decoratedHref, decoratedText, key) => (
                <a
                  rel="noopener noreferrer"
                  href={decoratedHref
                    .toLocaleLowerCase()
                    .replace("https://applycae.com", "")}
                  key={key}
                  style={{ color: "#1a73e8", textDecoration: "underline" }}
                >
                  {decoratedText}
                </a>
              )}
            >
              {data.text}
            </Linkify>
          </Typography>
        ) : null}

        <span className="chat-bubble-meta">
          {moment.unix(data?.dateTime).format("h:mm A")}
          {data.isEdit && !data.isDeleted ? " · edited" : ""}
        </span>
      </div>
    </div>
  );
};
